import {useEffect} from "react";
import Layout from "components/layout/Layout";
import {IntroSection, TokenSection, ThirdSection, FourthSection, FifthSection} from "components/index";
import * as Scroll from 'react-scroll';

let Element = Scroll.Element;
export default function Home() {
    useEffect(() => {
    });

    return (
        <Layout title="Million Tokens">
            <IntroSection></IntroSection>
            <Element name="tokens">
                <TokenSection></TokenSection>
            </Element>
            <ThirdSection></ThirdSection>
            <Element name="howtoworks">
                <FourthSection></FourthSection>
            </Element>
            <FifthSection></FifthSection>
        </Layout>
    )
}
